import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const MessagePage = () => {
  const navigate = useNavigate();

  return (
    <Container className="vh-100 d-flex justify-content-center align-items-center">
      <div
        className="text-center p-4"
        style={{
          maxWidth: "350px",
          width: "100%",
        }}
      >
        {/* Logo */}
        <img src="/assets/logo/barejadham1.png" alt="logo" height="50" />

        {/* Message */}
        <h5 className="fw-bold text-success mb-1">Thank You</h5>

        <p className="text-muted mb-3" style={{ fontSize: "15px" }}>
          Our team will contact you shortly to complete the verification
          process.
        </p>

        {/* Button */}
        <Button
          style={{
            backgroundColor: "#FF4F00",
            border: "none",
            padding: "6px 18px",
            fontSize: "14px",
          }}
          onClick={() => navigate("/", { replace: true })}
        >
          Back to Home
        </Button>
      </div>
    </Container>
  );
};

export default MessagePage;
